export default "__VITE_ASSET__CdiXYd05__"